import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { CONTACT_TYPES } from "@/lib/inquiry";

const EMPTY = { name: "", organisation: "", email: "", phone: "", designation: "", type: "prospect", notes: "" };

const F = ({ label, children }) => (
  <div><Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label><div className="mt-1">{children}</div></div>
);

export const ContactFormDialog = ({ open, contact, onClose, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(contact ? { ...EMPTY, ...contact } : EMPTY); }, [open, contact]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e?.target ? e.target.value : e }));
  const save = async () => {
    setBusy(true);
    try {
      const body = { name: f.name, organisation: f.organisation || null, email: f.email || null, phone: f.phone || null,
        designation: f.designation || null, type: f.type, notes: f.notes || null };
      const r = contact?.id ? await api.patch(`/contacts/${contact.id}`, body) : await api.post("/contacts", body);
      toast.success(contact?.id ? "Contact updated" : "Contact added");
      onSaved(r.data);
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="contact-form-dialog">
        <DialogHeader><DialogTitle>{contact?.id ? "Edit contact" : "New contact"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <F label="Name *"><Input data-testid="contact-name" value={f.name} onChange={set("name")} /></F>
          <F label="Type">
            <Select value={f.type} onValueChange={set("type")}>
              <SelectTrigger data-testid="contact-type"><SelectValue /></SelectTrigger>
              <SelectContent>{CONTACT_TYPES.map((t) => <SelectItem key={t} value={t} className="capitalize">{t}</SelectItem>)}</SelectContent>
            </Select>
          </F>
          <F label="Organisation"><Input data-testid="contact-org" value={f.organisation || ""} onChange={set("organisation")} /></F>
          <F label="Designation"><Input data-testid="contact-designation" value={f.designation || ""} onChange={set("designation")} /></F>
          <F label="Email"><Input data-testid="contact-email" type="email" value={f.email || ""} onChange={set("email")} /></F>
          <F label="Phone"><Input data-testid="contact-phone" value={f.phone || ""} onChange={set("phone")} /></F>
          <div className="col-span-2"><F label="Notes"><Textarea data-testid="contact-notes" rows={2} value={f.notes || ""} onChange={set("notes")} /></F></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="contact-save" disabled={!f.name.trim() || busy} onClick={save} className="bg-blue-700 hover:bg-blue-800 text-white">{busy ? "Saving…" : "Save contact"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
